import allocations from './repositories/allocations';
import circlesRepository from './repositories/circlesRepository';
import employees from './repositories/employees';
import forecasts from './repositories/forecasts';
import milestones from './repositories/milestones';
import overallocations from './repositories/overallocations';
import groups from './repositories/groups';

export default {
  allocations,
  circlesRepository,
  employees,
  forecasts,
  milestones,
  overallocations,
  groups
};
